import AbstractContext from '@/shared/models/AbstractContext';
import Sorting from '@/shared/models/Sorting';
import { removeById } from '@/shared/utils';
import AuditAccessFilters from './AuditAccessFilters';
import RestrictedAccessRecord, { RestrictedAccessRecordId } from './RestrictedAccessRecord';

export default class AuditAccessContext extends AbstractContext {
  constructor(
    readonly filters: AuditAccessFilters,
    private restrictedAccessRecords: Array<RestrictedAccessRecord>,
  ) {
    super();
  }

  getRestrictedAccessRecords(): Array<RestrictedAccessRecord> {
    return this.restrictedAccessRecords;
  }

  removeRestrictedAccessRecord(id: RestrictedAccessRecordId): void {
    removeById(this.restrictedAccessRecords, id);
  }

  sortSearchResults(sorting: Sorting<RestrictedAccessRecord>): void {
    this.restrictedAccessRecords = sorting.applyTo(this.restrictedAccessRecords);
  }
}